module.exports = __webpack_public_path__ + "static/img1-1d2f3e106a0c43670a33080e839b73ea.jpg";